import { getKneelResponse } from '@/pages/Onboarding/options/KneelResponse/utils/getKneelResponse';
import { getLifeControlIdByTitle } from '@/pages/Onboarding/options/LifeControl/utils/getLifeControl';
import { getToolsChoiceIdByTitle } from '@/pages/Onboarding/options/Tools/utils/getToolsChoice';
import { getVoiceStyleIdByTitle } from '@/pages/Onboarding/options/VoiceStyle/utils/getVoiceStyle';

import { layoutDataDefault } from '../constants';

import type { LayoutDataType } from '../types';

export const normalizeOnbDataToForm = (
  onb_data: LayoutDataType,
): LayoutDataType => {
  return {
    ...layoutDataDefault,
    life_control: getLifeControlIdByTitle(onb_data.life_control),
    kneel_response: getKneelResponse(onb_data.kneel_response),
    voice_style: getVoiceStyleIdByTitle(onb_data.voice_style),
    tools: getToolsChoiceIdByTitle(onb_data.tools),
    name: onb_data.name || layoutDataDefault.name,
  };
};
